import { useSimulation } from "../simulation/SimulationProvider";
import type { SimulationGuides } from "../simulation/state";

const guides: readonly {
  readonly key: keyof SimulationGuides;
  readonly label: string;
}[] = [
  { key: "sunlightRays", label: "Sunlight rays" },
  { key: "orbitalPlanes", label: "Orbital planes" },
  { key: "phaseLabels", label: "Phase labels" },
  { key: "moonTerminator", label: "Day–night boundary" },
  { key: "moonRotationMarker", label: "Near-side marker (red dot)" },
  { key: "allPhasePositions", label: "All phase positions" },
  { key: "earthRotation", label: "Earth rotation" },
  { key: "eclipseNodes", label: "Eclipse nodes" },
  { key: "classroomMode", label: "Classroom demo mode" },
];

export function ViewControls() {
  const { resetView, state, toggleGuide } = useSimulation();

  return (
    <fieldset className="control-group view-controls">
      <legend>View guides</legend>
      <div className="guide-grid">
        {guides.map(({ key, label }) => (
          <label key={key} className="checkbox-control">
            <input
              type="checkbox"
              checked={state.guides[key]}
              onChange={() => toggleGuide(key)}
            />
            {label}
          </label>
        ))}
      </div>
      <button type="button" onClick={resetView}>
        Reset view
      </button>
    </fieldset>
  );
}
